// extracted by mini-css-extract-plugin
export default {"sec-btn1":"PaperFormat_sec-btn1__g6a1p","edit":"PaperFormat_edit__XrDKZ","activate":"PaperFormat_activate__odC3Y","flex":"PaperFormat_flex__t3ygv"};